<template>
  <Modal ref="Modal">
    <div class="ntax-popup">
      <div class="ntax-popup-title">
        로그인 확인
        <a @click="close">
          <span class="glyphicon glyphicon-remove"></span>
        </a>
      </div>

      <div class="popup-table">
        <div class="popup-table-title">로그인 후 사용 가능합니다.</div>
        <table class="table">
          <tbody>
            <tr>
              <td style="padding-top:15px!important;">
                <a href="#" @click.prevent="goToLoginPage('P')">
                  <img src="@/assets/images/login-button-user.png" />
                </a>
              </td>
              <td v-if="isAgentShow" style="padding-top:15px!important;">
                <a href="#" @click.prevent="goToLoginPage('A')">
                  <img src="@/assets/images/login-button-agent.png" />
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="ntax-button-box">
        <button class="btn btn-sm btn-primary" @click="close">
          <span class="glyphicon glyphicon-remove"></span> 닫기
        </button>
      </div>
    </div>
    <!-- /ntax-popup -->
  </Modal>
</template>

<script>
import Modal from "@/components/common/Modal.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    Modal,
  },
  data() {
    return {
      isShow: false,
      nextUrl: "",
    };
  },
  computed: {
    isAgentShow() {
      return !["CRP", "KMC", "CAK", "EGIC", "KOSCA", "ICMS"].includes(
        this.userType
      );
    },
    ...mapGetters("sessionStore", ["userType",]),
  },
  methods: {
    open(nextUrl) {
      if (nextUrl) {
        this.nextUrl = nextUrl;
      }
      this.$refs.Modal.open();
    },
    close() {
      this.$refs.Modal.close();
    },
    async goToLoginPage(type) {
      this.$store.dispatch("sessionStore/ADD_APPLY_INFO", { sendType: type });
 
      if (confirm("'확인'버튼을 누르면 로그인 페이지로 이동합니다.")) {
        this.close();
        
        if (type == "A") {
          this.$router.push({name: "agentLogin", params: {nextUrl: this.nextUrl}});
        } else {
          this.$router.push({name: "principalLogin", params: {nextUrl: this.nextUrl}});
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  cursor: pointer;
}   
</style>